import { useRef, useEffect } from 'react';

type SoundType = 'start' | 'score' | 'achievement' | 'bonus';

const soundFiles: Record<SoundType, string> = {
  start: '/sound/start.mp3',
  score: '/sound/score.mp3',
  achievement: '/sound/achiev.wav',
  bonus: '/sound/bonus.mp3'
};

export function useSound() {
  const audioRefs = useRef<Record<string, HTMLAudioElement>>({});

  // Preload sounds
  useEffect(() => {
    Object.entries(soundFiles).forEach(([key, src]) => {
      const audio = new Audio(src);
      audio.load();
      audioRefs.current[key] = audio;
    });

    return () => {
      // Cleanup audio elements
      Object.values(audioRefs.current).forEach(audio => {
        audio.pause();
        audio.src = '';
      });
    };
  }, []);

  const playSound = (type: SoundType) => {
    const audio = audioRefs.current[type];
    if (audio) {
      audio.currentTime = 0; // Rewind to the start
      audio.play().catch(error => {
        console.warn(`Failed to play ${type} sound:`, error);
      });
    }
  };

  return { playSound };
}
